module.exports = __webpack_public_path__ + "static/img/icon-promotion.cbcf335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-promotion.png
// module id = 1mPL
// module chunks = 1